import api from './api';
import ENDPOINTS from './endpoints';

export async function fetchKitAssignment(token) {
  const { data: envelope } = await api.get(ENDPOINTS.KIT_ASSIGNMENT.DETAIL, {
    params: { token },
  });
  return envelope?.data || envelope;
}

export async function submitKitAssignments(token, assignments, finalize = false, source = '') {
  const payload = {
    token,
    assignments,
    finalize,
  };
  if (source) {
    payload.completion_source = source;
  }
  const { data: envelope } = await api.post(ENDPOINTS.KIT_ASSIGNMENT.DETAIL, payload);
  return envelope?.data || envelope;
}
